export default "images/导航 (1).png";